export default __webpack_public_path__ + "static/5-41e5c545101ac993c7df7a5f36ed1f42.jpg";